import { skipToken, useQuery } from '@tanstack/react-query';
import { orpc } from '@/api/rpc/client';

export function useTwilioAccount({
  organizationId,
}: {
  organizationId: string | undefined;
}) {
  return useQuery({
    ...orpc.twilio.getAccount.queryOptions({
      input: organizationId ? { organizationId } : skipToken,
    }),
    enabled: Boolean(organizationId),
  });
}
